import * as React from 'react';

import { Typography } from 'omakase';
import { core } from '@tock/coretypes';
import { cropImageUrl } from '@tock/images';
import { css } from '@emotion/react';
import { getCountryFromMetro } from 'utils/profileUtils';
import { useHistory } from 'react-router';
import CircleImage from 'components/profile/CircleImage';
import clsx from 'clsx';

export const DEFAULT_CITY_URL =
  'https://storage.googleapis.com/tock-public-assets/images-profile/city-default.png';

interface Props {
  destination: core.IMetroArea;
  onClick(metroId: number): void;
}

const cityNameText = () => css`
  overflow: hidden;
  textoverflow: ellipsis;
`;

const DestinationCard = ({ destination }: Props) => {
  const history = useHistory();

  const disabled =
    destination.alwaysDisplayAsDestinationCity && !destination.isFeatured && !destination.isActive;

  const handleClick = () => {
    if (disabled) {
      return;
    }
    history.push(`/city/${destination.slug}`);
  };

  const handleEnter = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter') {
      handleClick();
    }
  };
  const destinationImageUrl =
    (destination.image && destination.image.length > 0 && destination.image[0].imageUrl) ||
    DEFAULT_CITY_URL;
  const destinationImageBackingColor =
    destination.image && destination.image.length > 0 && destination.image[0].dominantColor;
  const country = getCountryFromMetro(destination);

  return (
    <div
      role="button"
      tabIndex={disabled ? -1 : 0}
      className={clsx('DestinationCard-container', { disabled })}
      onClick={handleClick}
      onKeyPress={handleEnter}
    >
      <div className="DestinationsCard-image-container">
        <CircleImage
          className="DestinationsCard-image"
          imageUrl={cropImageUrl(destinationImageUrl, 230, 230)}
          backgroundColor={destinationImageBackingColor || undefined}
        />
      </div>
      <div className="DestinationsCard-text">
        <div className="DestinationCard-name">
          <Typography css={cityNameText} component="h3" variant="body01Strong">
            {destination.name}
          </Typography>
        </div>
        {country && (
          <div className="DestinationCard-country">
            <Typography component="span" variant="body02">
              {country}
            </Typography>
          </div>
        )}
      </div>
    </div>
  );
};

export default DestinationCard;
